import { observer } from 'mobx-react'
import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import BundleLevels from './BundleLevels'
import DummyCounter from 'components/ContentBox/Global/Counter/DummyCounter'
import './AddBundle.scss'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'

const AddBundle = () => {
  const {
    getModalValues: { name, age, program, test_duration },
    changeValue,
    check,
  } = asideModalStore

  return (
    <div className='placementTestAddBundle'>
      <div className='modalAddPayment'>
        <div className='modalAddPayment__field'>
          <FormLabel isRequired>Название:</FormLabel>
          <FormInput isError={check('name')}>
            <input
              placeholder='Введите название связки'
              value={name || ''}
              onChange={(e) => changeValue(e.target.value, 'name')}
            />
          </FormInput>
        </div>
        <div className='modalAddPayment__row'>
          <div className='modalAddPayment__field'>
            <FormLabel isRequired>Возрастная категория:</FormLabel>
            <SelectCustom
              placeholder='Выберите возраст'
              apiLink='db/age'
              valueID={age}
              apiConfParams={{ limit: 999 }}
              sortKey='name'
              onChange={(o) => changeValue(o.id, 'age')}
              isSearchable
              error={check('age')}
            />
          </div>
          <div className='modalAddPayment__field'>
            <FormLabel isRequired>Программа обучения:</FormLabel>
            <SelectCustom
              placeholder='Выберите программу'
              apiLink='db/programs'
              valueID={program}
              apiConfParams={{ limit: 999 }}
              sortKey='name'
              onChange={(o) => changeValue(o.id, 'program')}
              isSearchable
              error={check('program')}
            />
          </div>
        </div>
        <div className='modalAddPayment__field'>
          <FormLabel isRequired>Продолжительность теста (мин.):</FormLabel>
          <DummyCounter
            value={test_duration || 60}
            onChange={(val, name) =>
              changeValue(val <= 0 ? test_duration : val, name)
            }
            name='test_duration'
          />
        </div>
        <BundleLevels />
      </div>
    </div>
  )
}
export default observer(AddBundle)
